
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/producers/[...slug]",
      function () {
        return require("private-next-pages/producers/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/producers/[...slug]"])
      });
    }
  